import { useTranslation } from 'react-i18next';

import { Alert, Button, Modal } from '@hotjar/hotsauce';
import type { Organization } from '@hotjar/organization';

interface Props {
  isOpen: boolean;
  onDone: () => void;
  onConnectAnotherOrganization: () => void;
  organization: Organization;
}

export const ConnectionSuccessModal = ({
  isOpen,
  onDone,
  onConnectAnotherOrganization,
  organization,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  const { name: organizationName } = organization;
  const title = t('common:settings.sso.connection-success-modal.title');

  return (
    <Modal
      isOpen={isOpen}
      contentLabel={title}
      onClose={onDone}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      size="m"
    >
      <Modal.Header title={title} />

      <Modal.Body>
        <Alert kind="success">
          {t('common:settings.sso.connection-success-modal.description', { organizationName })}
        </Alert>
      </Modal.Body>

      <Modal.Footer>
        <Button kind="secondary" onClick={onConnectAnotherOrganization}>
          {t('common:settings.sso.connection-success-modal.connect-another-organization')}
        </Button>

        <Button kind="primary" onClick={onDone}>
          {t('common:settings.sso.connection-success-modal.done')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
